import Vue from 'vue'
import Vuetify from 'vuetify'
// Material design icons
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const opts = {}

export default new Vuetify(opts)
